import { Component } from '@angular/core';

@Component({
  template: require('./error-page.component.html'),
  styles: [require('./error-page.component.css')]
})
export class ErrorPageComponent {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pages/error-page/error-page.component.ts
 **/